<template>
    <div>

        <el-card>

            <div slot="header">
                <el-form :inline="true" :model="formData" class="search-form">

                    <el-form-item label="组名搜索:" >
                        <el-input v-model="formData.group_name" placeholder="请输入组名..." clearable  class="common-input" @keyup.enter.native="searchEvent"></el-input>
                    </el-form-item>

                <router-link :to="{ path:'/systemFeishuCabupdata', query:{groupName:'CAB组',callback: request }}">
                    <el-button type="primary">新增</el-button>
                </router-link>
                <el-button type="primary" @click="searchEvent">查询</el-button>
                </el-form>
            </div>
        </el-card>

        <el-card>
            <el-table :data="tableData"
                :span-method="objectSpanMethod"
                border :cell-style="{background:'#fff'}"
                style="width: 100%; margin-top: 20px">
<!--                <el-table-column-->
<!--                    prop="group_id" label="ID" width="180">-->
<!--                </el-table-column>-->
                <el-table-column prop="group_name" label="组织结构名称">
                </el-table-column>
                <el-table-column prop="name" label="人员名称">
                </el-table-column>
                <el-table-column prop="priority" label="审批优先级">
                </el-table-column>
                <el-table-column prop="name" label="人员操作">
                    <template slot-scope='scope' v-if="scope.row.name !=null ">
                        <el-button type="text" @click="personeditEvent(scope.row.user_group_id,scope.row.priority)">编辑</el-button>
                        <el-button class="table-del-btn" type="text" @click="deletePerson(scope.$index, tableData, scope.row.internal_userid, scope.row.group_id)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="组操作">
                    <template slot-scope="scope" >
                        <router-link :to="{ path:'/systemFeishuUserAdd', query:{callback: request,id:scope.row.group_id,type:'group'}}">
                            <el-button type="text" >添加人员</el-button>
                        </router-link>
                        <router-link :to="{ path:'/systemFeishuCabupdata', query:{ row: scope.row, type:'edit',  callback: request }}">
                            <el-button type="text">编辑</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0076-F'" class="table-del-btn" type="text" @click="deleteRole('group', scope.row.group_id)" >删除</el-button>

                    </template>
                </el-table-column>

            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="formData.page_index"
                           :page-sizes="[10,20]"
                           :page-size="formData.page_size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

        </el-card>
        <el-dialog title="审批优先级编辑" :visible.sync="dialogFormVisible">
            <el-form label-width="90px" v-model="dialogForm">
                <br/>
                <el-form-item label="审批优先级"  >
                    <el-input v-model="dialogForm.priority" type="number" min="1" class="form-input"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogFormSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import services from './system.services'

    export default {

        data() {
            return {
                loading: true,
                tableData:[],
                formData:{
                    page_size:10,
                    page_index:1,
                    group_name:''
                },
                total:0,
                dialogFormVisible:false,
                dialogForm:{
                    user_group_id:'',
                    priority:1
                }
            }
        },

        mounted() {
            this.request()
        },

        methods: {
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0 || columnIndex === 4) {
                    // if (rowIndex % this.rowSpan === 0) {
                    return {
                        rowspan: row.merge_row,
                        colspan: 1
                    };
                    // if (row.merge_row !== 0) {
                    //     return {
                    //         rowspan: row.merge_row,
                    //         colspan: 1
                    //     };
                    // } else {
                    //     return {
                    //         rowspan: 0,
                    //         colspan: 0
                    //     };
                    // }
                }
            },
            personeditEvent(user_group_id,priority){
                this.dialogForm.user_group_id = user_group_id
                this.dialogForm.priority = priority
                this.dialogFormVisible = true
            },
        // 请求数据
            request() {
                services.cabGroupList(this.formData)
                    .then(res => {
                        this.tableData = res.lis
                        this.total = res.total
                    })
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.loading = false)
            },
            searchEvent(){
                this.formData.page_index  = 1;
                this.request();
            },
            deletePerson(index, rows, user, id) {
                this.$confirm('此操作将永久删除该人员, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        services.userGroupDelete({ groupId: id, internalUserid: [user] })
                            .then(res => {
                                rows.splice(index, 1);
                                this.$message.success('删除成功')
                                this.request()
                            })
                    }).catch(() => this.$messag.info('已取消删除'));
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.formData.page_size = val;
                if(this.formData.page_index > pages ){
                    this.formData.page_index  = 1;
                };
                this.request()
            },
            handleCurrentChange(val){
                this.formData.page_index = val;
                this.request();
            },
            dialogFormSubmit(){
                // console.log(this.dialogForm)
                // groupPriorityEdit
                this.dialogForm.priority = Number(this.dialogForm.priority)
                services.groupPriorityEdit(this.dialogForm)
                    .then(() => {
                        this.$message.success('修改成功！')
                        this.request()
                    })
                    .catch(err => this.$message.error(err.message))
                this.dialogFormVisible = false
            },
            // 删除某一项
            deleteRole(type, id) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        if (type === 'group') {
                            services.groupDelete({groupId: id})
                                .then(res => {
                                    this.$message.success('删除成功!')
                                    this.request()
                                    // this.$router.push({
                                    //     path:'/redirect',
                                    //     query:{
                                    //         url:'/systemFeishuCabGroup'
                                    //     }
                                    // })
                                })
                                .catch(err => this.$message.error(err.message))
                        } else {
                            services.departmentDelete({departmentId: id})
                                .then(res => {
                                    this.$message.success('删除成功!')
                                    this.request()
                                    // this.$router.push({
                                    //     path:'/redirect',
                                    //     query:{
                                    //         url:'/systemFeishuCabGroup'
                                    //     }
                                    // })
                                })
                                .catch(err => this.$message.error(err.message))
                        }
                    })
                    .catch(() => this.$message.info('已取消删除'))
            }
        }



}
</script>

<style lang="scss" scoped>

</style>
